__turbopack_context__.v({
  "root": "ComponentOverviewHit-Simple-module-scss-module__T2z9Tq__root",
});
